module.exports = __webpack_public_path__ + "static/media/Raleway-Medium.b952c3c8.ttf";